import { Message } from "../Interfaces/messagesInterface";


export const getLatestReadMessage = (messages: Message[]) => {
  const readMessages = messages.filter((message) => message.system_user && message.read_time);

  const sortedMessages = readMessages.sort((a, b) => {
    const timeA = a.read_time || a.created_at;
    const timeB = b.read_time || b.created_at;
    return timeB - timeA; 
  });

  return sortedMessages[0];
};

